var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('payments-vouchers-export-component',{attrs:{"ui":_vm.ui}})}
var staticRenderFns = []

export { render, staticRenderFns }